module.exports = __webpack_public_path__ + "fonts/righthand-extrabold-personal.11117a06.ttf";